<script lang="ts">
export default {
  name: 'TextInput',
};
</script>

<script setup lang="ts">
import { addCommas, removeCommas, toCurrency } from '@/utilities/Number';
import { computed, useAttrs } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const model = defineModel<string>();
const attrs = useAttrs();

const inputValue = computed({
  get() {
    // Currency or Number
    if ((attrs.isNumber !== undefined || attrs.isCurrency !== undefined) && (model.value || model.value === '0')) {
      if (isNaN(Number(model.value)) || model.value?.endsWith('.')) {
        return model.value;
      }

     if (attrs.isCurrency !== undefined) {
       const n = Number(model.value)
       return toCurrency(n, {
         minimumFractionDigits: n % 1 === 0 ? 0 : 2,
         maximumFractionDigits: 2,
       });
     } else {
       return addCommas(model.value);
     }
    }

    // Percent
    if (attrs.isPercent !== undefined) {
      if (isNaN(Number(model.value)) || model.value?.endsWith('.')) {
        return model.value;
      }
      return model.value ? `${addCommas(model.value)}%` : '';
    }

    return model.value;
  },
  set(val: string) {
    // Currency or Number
    if (attrs.isCurrency !== undefined || attrs.isNumber !== undefined) {
      model.value = (removeCommas(val)?.toString() ?? '').replace('$', '');
      return;
    }

    // Percent
    if (attrs.isPercent !== undefined) {
      val = val.replaceAll('%', '');
      val = val.replaceAll(',', '');

      if (!isNaN(Number(model.value)) && model.value === val) {
        model.value = removeCommas(val.slice(0, -1))?.toString() ?? '';
        return;
      }

      model.value = removeCommas(val)?.toString() ?? '';
      return;
    }

    model.value = val;
    return;
  },
});

function handleInput(e: Event) {
  inputValue.value = (e.target as HTMLInputElement)?.value;
}

function handleKeyDown(e: KeyboardEvent) {
  if (attrs.isNumber !== undefined || attrs.isCurrency !== undefined || attrs.isPercent !== undefined) {
    if ([',', '$', '%']['includes'](e.key)) {
      e.preventDefault();
    }
  }
}
</script>

<template>
  <div class="relative flex items-center gap-1">
    <input
      type="text"
      v-bind="$attrs"
      class="input border-solid"
      :value="inputValue"
      @input="handleInput"
      @keydown="handleKeyDown" />
  </div>
</template>
